// Tamil — shared key set with the Flutter apps (lib/l10n).
// Auto-generated from the Dart source of truth; keep both in sync.
// Flat, dotted keys — i18n is configured with keySeparator:false.

const ta: Record<string, string> = {
  "common.save": "சேமி",
  "common.cancel": "ரத்து செய்",
  "common.delete": "நீக்கு",
  "common.edit": "திருத்து",
  "common.add": "சேர்",
  "common.close": "மூடு",
  "common.back": "பின்",
  "common.done": "முடிந்தது",
  "common.yes": "ஆம்",
  "common.no": "இல்லை",
  "common.confirm": "உறுதிப்படுத்து",
  "common.search": "தேடு",
  "common.retry": "மீண்டும் முயற்சி",
  "common.loading": "ஏற்றுகிறது…",
  "common.offline": "ஆஃப்லைன்",
  "nav.settings": "அமைப்புகள்",
  "nav.orders": "ஆர்டர்கள்",
  "nav.tables": "மேசைகள்",
  "nav.menu": "மெனு",
  "nav.reports": "அறிக்கைகள்",
  "roles.pos": "விற்பனை மையம்",
  "roles.kds": "சமையலறை திரை",
  "roles.customer": "வாடிக்கையாளர் திரை",
  "roles.captain": "கேப்டன்",
  "roles.kiosk": "சுய-ஆர்டர் கியோஸ்க்",
  "order.dineIn": "உள்ளே சாப்பிடு",
  "order.takeaway": "பார்சல்",
  "order.delivery": "டெலிவரி",
  "order.quickBill": "விரைவு பில்",
  "order.newOrder": "புதிய ஆர்டர்",
  "order.sendToKitchen": "சமையலறைக்கு அனுப்பு",
  "order.addItem": "உருப்படி சேர்",
  "order.cart": "வண்டி",
  "order.empty": "இன்னும் உருப்படிகள் இல்லை",
  "bill.settle": "பில் செலுத்து",
  "bill.subtotal": "கூட்டுத்தொகை",
  "bill.discount": "தள்ளுபடி",
  "bill.total": "மொத்தம்",
  "bill.gst": "ஜிஎஸ்டி",
  "bill.customerName": "வாடிக்கையாளர் பெயர்",
  "bill.token": "டோக்கன்",
  "bill.billNo": "பில் எண்",
  "bill.splitBill": "பில் பிரி",
  "bill.splitBySeat": "இருக்கை வாரியாக பிரி",
  "bill.pay": "செலுத்து",
  "bill.print": "அச்சிடு",
  "bill.paid": "செலுத்தப்பட்டது",
  "bill.pending": "நிலுவையில்",
  "table.free": "காலி",
  "table.occupied": "நிரம்பியது",
  "table.transfer": "மாற்று",
  "table.merge": "இணை",
  "settings.language": "மொழி",
  "settings.tax": "வரி",
  "settings.printing": "அச்சிடல்",
  "settings.account": "கணக்கு & திட்டம்",
  "settings.general": "பொது",
  "settings.deviceMode": "சாதன பயன்முறை",
  "settings.chooseLanguage": "மொழியைத் தேர்ந்தெடு",
  "nav.order": "ஆர்டர்",
  "nav.online": "ஆன்லைன்",
  "nav.activity": "செயல்பாடு",
  "nav.history": "வரலாறு",
  "nav.import": "இறக்குமதி",
  "nav.endShift": "ஷிப்டை முடி",
  "settings.title": "அமைப்புகள்",
  "settings.subtitle": "கடை, வரி, பிரிண்டர்கள், பாத்திரங்கள் & பில் வடிவம்",
  "settings.sectionOutlet": "கடை & பிராண்டிங்",
  "settings.sectionTax": "வரி & ஜிஎஸ்டி",
  "settings.sectionPrinters": "பிரிண்டர்கள் & கேஓடி",
  "settings.sectionRoles": "பாத்திரங்கள் & அனுமதிகள்",
  "settings.sectionBillFormat": "பில் வடிவம்",
  "settings.sectionChannels": "ஆன்லைன் சேனல்கள்",
  "settings.sectionAccount": "கணக்கு & திட்டங்கள்",
  "settings.sectionAbout": "பற்றி & புதுப்பிப்புகள்",
  "order.viewCart": "வண்டியைப் பார்",
  "order.categories": "வகைகள்",
  "order.tapToBuild": "ஆர்டரை உருவாக்க உணவுகளைத் தட்டவும்",
  "order.addNote": "குறிப்பு சேர்",
  "order.searchDishes": "உணவுகளைத் தேடு",
  "bill.settleAndPrint": "செலுத்தி அச்சிடு",
  "menu.title": "மெனு & உருப்படிகள்",
  "menu.searchItems": "உருப்படிகளைத் தேடு…",
  "menu.noItems": "இங்கே உருப்படிகள் இல்லை",
  "menu.addItemBtn": "உருப்படி சேர்",
  "menu.tapAddItem": "உருவாக்க “உருப்படி சேர்” தட்டவும்",
  "menu.addCategory": "வகை சேர்",
  "menu.newCategory": "புதிய வகை",
  "order.allFired": "அனைத்தும் அனுப்பப்பட்டன",
  "bill.settling": "செலுத்துகிறது…"
};

export default ta;
